import * as yup from 'yup';

export const passwordYup = yup.string().required('Field is required').min(8, 'Password must have 8 or more characters');
